import { getLegislation } from '../legislation'

export function getRedactionReasonPlaceholder(reasonLabel = 'Personal information', themeName) {
  return `e.g. ${reasonLabel} — ${getLegislation(themeName).redactionExample}`
}
